import React, { useState, useEffect, forwardRef } from "react";
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import { Paper, IconButton, Modal, FormControlLabel, Checkbox, Card, CardHeader, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, CardContent, Box, Button, TableCell, TableBody, TableRow,  makeStyles, Grid, Select, MenuItem, TextField } from '@material-ui/core';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Edit, Cancel } from '@mui/icons-material';
import "./LearnAdmin.css";
import AdminTable from '../Components/AdminTable';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import axios from "axios";
import Cookies from 'universal-cookie';
import { useHistory } from 'react-router';
export default function LearnAdmin() {
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [error, setErrorMessage] = useState('');
  const [success, setSuccessMessage] = useState('');
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [type, setType] = useState("");
  const [titleEdit, setTitleEdit] = useState("");
  const [contentEdit, setContentEdit] = useState("");
  const [typeEdit, setTypeEdit] = useState("");
  const [idPostEdit, setIdPostEdit] = useState(0);
  const history = useHistory();
  const [change, setChange] = useState(false);
  const [changeFlag, setChangeFlag] = useState(false);
  const [changeQuiz, setChangeQuiz] = useState(false);
  const [modalCreate, setModalCreate] = useState(false);
  const [modalCreateContent, setModalCreateContent] = useState(false);
  const [modalEditContent, setModalEditContent] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalQuiz, setModalQuiz] = useState(false);
  const [modalQuizEdit, setModalQuizEdit] = useState(false);
  const [question, setQuestion] = useState("");
  const [flag, setFlag] = useState("");
  const [score, setScore] = useState(0);
  const [learn_id, setLearn_id] = useState(0);
  const [questionEdit, setQuestionEdit] = useState("");
  const [flagEdit, setFlagEdit] = useState("");
  const [scoreEdit, setScoreEdit] = useState(0);
  const [flag_idEdit, setFlag_idEdit] = useState(0);
  const [level, setLevel] = useState("");
  const [levelEdit, setLevelEdit] = useState("");
  const [questionQuiz, setQuestionQuiz] = useState("");
  const [levelQuiz, setLevelQuiz] = useState("");
  const [answerQuiz, setAnswerQuiz] = useState("");
  const [answerOne, setAnswerOne] = useState("");
  const [answerTwo, setAnswerTwo] = useState("");
  const [answerThree, setAnswerThree] = useState("");
  const [answerFour, setAnswerFour] = useState("");
  const [quizIDEdit, setQuizIDEdit] = useState(0);
  const [questionQuizEdit, setQuestionQuizEdit] = useState("");
  const [answerQuizEdit, setAnswerQuizEdit] = useState("");
  const [answerOneEdit, setAnswerOneEdit] = useState("");
  const [answerTwoEdit, setAnswerTwoEdit] = useState("");
  const [answerThreeEdit, setAnswerThreeEdit] = useState("");
  const [answerFourEdit, setAnswerFourEdit] = useState("");
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [openRemoveDialogFlag, setOpenRemoveDialogFlag] = useState(false);
  const [openRemoveDialogQuiz, setOpenRemoveDialogQuiz] = useState(false);
  const [recordsFlag, setRecordsFlag] = useState([]);
  const [recordsQuiz, setRecordsQuiz] = useState([]);
  const [showPre, setShowPre] = useState(false);
  const [showFacil, setShowFacil] = useState(false);
  const [showMedia, setShowMedia] = useState(false);
  const [showDificil, setShowDificil] = useState(false);
  const cookies = new Cookies();
  const userToken = cookies.get('tokenCTF');
  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const points = [
    {
      value: '',
      label: ''
    },
    {
      value: 50,
      label: '50'
    },
    {
      value: 100,
      label: '100'
    },
    {
      value: 150,
      label: '150'
    },
    {
      value: 200,
      label: '200'
    },
    {
      value: 250,
      label: '250'
    },
    {
      value: 300,
      label: '300'
    },
    {
      value: 350,
      label: '350'
    },
    {
      value: 400,
      label: '400'
    },
    {
      value: 450,
      label: '450'
    },
    {
      value: 500,
      label: '500'
    }
  ];
  const useStyles = makeStyles(theme => ({
    pageContentTeam: {
      marginTop: '15vh',
      marginLeft: '24vw',
      width: '70%',
      padding: theme.spacing(3),
      overflowX: 'auto',
      overflowY: 'hidden',
      textAlign: 'center',
      zIndex: '1',
    },
    pageContentTeam2: {
      marginTop: '3vh',
      marginLeft: '24vw',
      width: '70%',
      padding: theme.spacing(3),
      overflowX: 'auto',
      overflowY: 'hidden',
      textAlign: 'center',
      zIndex: '1',
    },
    headContent: {
      display: 'flex',
    },
    selectCa: {
      width: '50%',
      marginLeft: '5%',
    },
    headTable: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    modalCreate: {
      position: 'absolute',
      width: '60vw',
      backgroundColor: 'white',
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      //padding: '16px 32px 24px',
      padding: theme.spacing(2, 4, 3, 4),
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    modalEdit: {
      position: 'absolute',
      width: '60vw',
      backgroundColor: 'white',
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      //padding: '16px 32px 24px',
      padding: theme.spacing(2, 4, 3, 4),
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    buttonModified: {
      margin: theme.spacing(1),
    },
    card: {
      marginTop: '3vh',
      marginLeft: '30vw',
      marginBottom: '3vh',
      width: '60%',
      padding: theme.spacing(3),
      overflowY: 'hidden',
      textAlign: 'center',
    },
    quiz: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',

    },
    buttonsQuiz: {
      display: 'flex',
      flexDirection: 'column',
      width: '20%',
      marginRight: theme.spacing(5),
      marginTop: theme.spacing(2),
    },

  }))
  const classes = useStyles();
  const [records, setRecords] = useState([])
  const [recordsTitles, setRecordsTitles] = useState([])
  const [removeModuleID, setRemoveModuleID] = useState(0);
  const [removeFlagID, setRemoveFlagID] = useState(0);
  const [removeQuizID, setRemoveQuizID] = useState(0);
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordShownEdit, setPasswordShownEdit] = useState(false);
  const [passwordShownQuiz, setPasswordShownQuiz] = useState(false);
  const [passwordShownQuizEdit, setPasswordShownQuizEdit] = useState(false);
  const headCells = [
    { id: 'title', label: 'Tema' },
    { id: 'category', label: 'Categoría', disableSorting: true },
    { id: 'level', label: 'Nivel' },
    { id: 'actions', label: 'Acciones', disableSorting: true },

  ]
  const headCellsFlag = [
    { id: 'module', label: 'Módulo' },
    { id: 'question', label: 'Pregunta' },
    { id: 'value', label: 'Valor', disableSorting: true },
    { id: 'actions', label: 'Acciones', disableSorting: true },
  ]
  const headCellsQuiz = [
    { id: 'question', label: 'Pregunta' },
    { id: 'level', label: 'Nivel' },
    { id: 'actions', label: 'Acciones', disableSorting: true },
  ]
  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting
  } = AdminTable(records, headCells);
  const {
    TblContainer: TblContainerFlag,
    TblHead: TblHeadFlag,
    TblPagination: TblPaginationFlag,
    recordsAfterPagingAndSorting: recordsAfterPagingAndSortingFlag
  } = AdminTable(recordsFlag, headCellsFlag);
  const {
    TblContainer: TblContainerQuiz,
    TblHead: TblHeadQuiz,
    TblPagination: TblPaginationQuiz,
    recordsAfterPagingAndSorting: recordsAfterPagingAndSortingQuiz
  } = AdminTable(recordsQuiz, headCellsQuiz);
  
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };
  const togglePasswordQuiz = () => {
    setPasswordShownQuiz(!passwordShownQuiz);
  };
  const togglePasswordQuizEdit = () => {
    setPasswordShownQuizEdit(!passwordShownQuizEdit);
  };
  const togglePasswordEdit = () => {
    setPasswordShownEdit(!passwordShownEdit);
  };
  const openCloseModal = () => {
    setModalCreate(!modalCreate);
  }
  const openCloseModalContent = () => {
    setModalCreateContent(!modalCreateContent);
    setLevel('Ninguno')
  }
  const openCloseModalContentEdit = () => {
    setModalEditContent(!modalEditContent);
  }
  const openCloseModalQuiz = () => {
    setModalQuiz(!modalQuiz);
    setLevelQuiz('');
  }
  const openCloseModalQuizEdit = () => {
    setModalQuizEdit(!modalQuizEdit);
  }

  const openModalEdit = (id) => {
    axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/getFlag`, {
      flag_id: id,
    }, {
      headers: { 'Authorization': userToken }
    }).then(res => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        setFlag_idEdit(res.data[0].learn_id);
        setQuestionEdit(res.data[0].question);
        setFlagEdit(res.data[0].flag);
        setScoreEdit(res.data[0].score);
        setModalEdit(true);
      }
    })
  }
  const openModalQuizEdit = (id) => {
    axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/getQuestion`, {
      question_id: id,
    }, {
      headers: { 'Authorization': userToken }
    }).then(res => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        setQuizIDEdit(res.data[0].question_id)
        setQuestionQuizEdit(res.data[0].question)
        setAnswerQuizEdit(res.data[0].correctAnswer);
        setAnswerOneEdit(res.data[0].answer1);
        setAnswerTwoEdit(res.data[0].answer2);
        setAnswerThreeEdit(res.data[0].answer3);
        setAnswerFourEdit(res.data[0].answer4);
        setModalQuizEdit(true);
      }
    })
  }
  const closeModalEdit = () => {
    setFlag_idEdit(0);
    setQuestionEdit("");
    setFlagEdit("");
    setScoreEdit(0);
    setModalEdit(false);
  }
  const closeModalEditQuiz = () => {
    setQuizIDEdit(0)
    setQuestionQuizEdit('')
    setAnswerQuizEdit('');
    setAnswerOneEdit('');
    setAnswerTwoEdit('');
    setAnswerThreeEdit('');
    setAnswerFourEdit('');
    setModalQuizEdit(false);
  }
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenError(false);
    setOpenSuccess(false);
  };
  function handleOpenRemoveDialog(id) {
    setOpenRemoveDialog(true);
    setRemoveModuleID(id);
  };
  function handleOpenRemoveDialogFlag(id) {
    setOpenRemoveDialogFlag(true);
    setRemoveFlagID(id);
  };
  function handleOpenRemoveDialogQuiz(id) {
    setOpenRemoveDialogQuiz(true);
    setRemoveQuizID(id);
  };
  const handleCloseRemoveDialog = () => {
    setOpenRemoveDialog(false);
    setRemoveModuleID(0);
  };
  const handleCloseRemoveDialogFlag = () => {
    setOpenRemoveDialogFlag(false);
    setRemoveFlagID(0);
  };
  const handleCloseRemoveDialogQuiz = () => {
    setOpenRemoveDialogQuiz(false);
    setRemoveQuizID(0);
  };
  useEffect(() => {
    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/getModules`, {
      headers: { 'Authorization': userToken }
    }
    ).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (response.data.noAdmin) {
        history.push('/user');
      }
      else {
        setRecords(response.data)
        setChange(false)
      }
    })
    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/getTitleContent`, {
      headers: { 'Authorization': userToken }
    }
    ).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (response.data.noAdmin) {
        history.push('/user');
      }
      else {
        setRecordsTitles(response.data);
      }
    })
  }, [change])
  useEffect(() => {
    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/getFlags`, {
      headers: { 'Authorization': userToken }
    }
    ).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (response.data.noAdmin) {
        history.push('/user');
      }
      else {
        setRecordsFlag(response.data)
        setChangeFlag(false)
      }

    })

  }, [changeFlag])
  useEffect(() => {
    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/getQuiz`, {
      headers: { 'Authorization': userToken }
    }
    ).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (response.data.noAdmin) {
        history.push('/user');
      }
      else {
        setRecordsQuiz(response.data)
        setChangeQuiz(false)
      }

    })


  }, [changeQuiz])
  //here
  useEffect(() => {
    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/settingsAdmin/getQuizConfig`, {
      headers: { 'Authorization': userToken }
    }
    ).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (response.data.noAdmin) {
        history.push('/user');
      }
      else {
        setShowPre(response.data[0].showQuizP === 'true');
        setShowFacil(response.data[0].showQuizF === 'true');
        setShowMedia(response.data[0].showQuizM === 'true');
        setShowDificil(response.data[0].showQuizD === 'true');
      }

    })


  }, [])
  const deleteContent = (id) => {
    axios.delete(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/deleteModule/${id}`, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }

      else {
        if (response.data.messageSuccess) {
          setChange(true)
          setChangeFlag(true)
          setOpenSuccess(true);
          setSuccessMessage(response.data.messageSuccess);
          setOpenRemoveDialog(false);
        }
        else {
          setOpenError(true);
          setErrorMessage(response.data.messageError);
        }
      }

    });
  }
  const onUpdateFlag = () => {
    axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/updateFlag`, {
      question: questionEdit,
      flag: flagEdit,
      score: scoreEdit,
      flag_id: flag_idEdit
    }, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }

      else {
        if (response.data.messageSuccess) {
          setChangeFlag(true)
          setOpenSuccess(true);
          setSuccessMessage(response.data.messageSuccess);
          closeModalEdit();
        }
        else {
          setOpenError(true);
          setErrorMessage(response.data.messageError);
        }
      }

    });
  }
  const onUpdateQuiz = () => {
    axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/updateQuiz`, {
      question_id: quizIDEdit,
      question: questionQuizEdit,
      answer1: answerOneEdit,
      answer2: answerTwoEdit,
      answer3: answerThreeEdit,
      answer4: answerFourEdit,
      correctAnswer: answerQuizEdit,
    }, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        if (response.data.messageSuccess) {
          setChangeQuiz(true)
          setOpenSuccess(true);
          setSuccessMessage(response.data.messageSuccess);
          closeModalEditQuiz();
        }
        else {
          setOpenError(true);
          setErrorMessage(response.data.messageError);
        }
      }

    });
  }
  const deleteFlag = (id) => {
    axios.delete(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/deleteFlag/${id}`, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (response.data.messageSuccess) {
        setOpenSuccess(true);
        setSuccessMessage(response.data.messageSuccess);
        setChangeFlag(true)
        setOpenRemoveDialogFlag(false);
      }
      else if (response.data.messageError) {
        setErrorMessage(response.data.messageError);
        setOpenError(true);
      }
      else {
        setErrorMessage('');
        setSuccessMessage('');
      }

    });
  }

  const deleteQuiz = (id) => {
    axios.delete(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/deleteQuiz/${id}`, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (response.data.messageSuccess && response.data.showP) {
        setShowPre(false);
        setOpenSuccess(true);
        setSuccessMessage(response.data.messageSuccess);
        setChangeQuiz(true)
        setOpenRemoveDialogQuiz(false);
      }
      else if (response.data.messageSuccess && response.data.showF) {
        setShowFacil(false);
        setOpenSuccess(true);
        setSuccessMessage(response.data.messageSuccess);
        setChangeQuiz(true)
        setOpenRemoveDialogQuiz(false);
      }
      else if (response.data.messageSuccess && response.data.showM) {
        setShowMedia(false);
        setOpenSuccess(true);
        setSuccessMessage(response.data.messageSuccess);
        setChangeQuiz(true)
        setOpenRemoveDialogQuiz(false);
      }
      else if (response.data.messageSuccess && response.data.showD) {
        setShowDificil(false);
        setOpenSuccess(true);
        setSuccessMessage(response.data.messageSuccess);
        setChangeQuiz(true)
        setOpenRemoveDialogQuiz(false);
      }
      else if (response.data.messageSuccess) {
        setOpenSuccess(true);
        setSuccessMessage(response.data.messageSuccess);
        setChangeQuiz(true)
        setOpenRemoveDialogQuiz(false);
      }
      else if (response.data.messageError) {
        setErrorMessage(response.data.messageError);
        setOpenError(true);
      }
      else {
        setErrorMessage('');
        setSuccessMessage('');
      }

    });
  }
  const modifyContent = (info) => {
    setTitleEdit(info.title)
    setContentEdit(info.content)
    setTypeEdit(info.category_id)
    setLevelEdit(info.level)
    setIdPostEdit(info.learn_id)
    setModalEditContent(true);
  }
  const handleSetContext = value => {
    setContent(value);
  };
  const handleSetContextEdit = value => {
    setContentEdit(value);
  };
  const submitContent = () => {
    axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/createModule`, {
      title: title,
      content: content,
      type: type,
      level: level
    }, {
      headers: { 'Authorization': userToken }
    }).then(res => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }

      else if (res.data.messageSuccess) {
        setSuccessMessage(res.data.messageSuccess);
        setOpenSuccess(true);
        setTitle("");
        setContent("");
        setType("");
        setLevel("");
        setChange(true);
        setModalCreateContent(false);
      }
      else {
        setErrorMessage(res.data.messageError);
        setOpenError(true);
      }
    })
  };
  const updateContent = () => {
    axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/updateModule`, {
    learn_id: idPostEdit,  
    title: titleEdit,
      content: contentEdit,
      type: typeEdit,
      level: levelEdit
    }, {
      headers: { 'Authorization': userToken }
    }).then(res => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }

      else if (res.data.messageSuccess) {
        setSuccessMessage(res.data.messageSuccess);
        setOpenSuccess(true);
        setTitleEdit("");
        setContentEdit("");
        setTypeEdit("");
        setLevelEdit("");
        setChange(true);
        setModalEditContent(false);
      }
      else {
        setErrorMessage(res.data.messageError);
        setOpenError(true);
      }
    })
  };
  const onSubmitFlag = (e) => {
    axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/createFlag`, {
      learn_id: learn_id,
      question: question,
      flag: flag,
      value: score,
    }, {
      headers: { 'Authorization': userToken }
    }).then(res => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (res.data.messageSuccess) {
        setSuccessMessage(res.data.messageSuccess);
        setOpenSuccess(true);
        setChangeFlag(true);
        setModalCreate(false);
        setLearn_id(0);
        setQuestion("");
        setFlag("");
        setScore(0);

      }
      else if (res.data.messageError) {
        setErrorMessage(res.data.messageError);
        setOpenError(true);
      }
      else {
        setErrorMessage('');
        setSuccessMessage('');
        setOpenSuccess(false);
        setOpenError(false);
      }
    })
  }
  const onSubmitQuiz = (e) => {
    axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/createQuiz`, {
      question: questionQuiz,
      level: levelQuiz,
      answer1: answerOne,
      answer2: answerTwo,
      answer3: answerThree,
      answer4: answerFour,
      correctAnswer: answerQuiz,
    }, {
      headers: { 'Authorization': userToken }
    }).then(res => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (res.data.messageSuccess) {
        setSuccessMessage(res.data.messageSuccess);
        setOpenSuccess(true);
        setLevelQuiz('');
        setModalQuiz(false);
        setChangeQuiz(true);
      }
      else if (res.data.messageError) {
        setErrorMessage(res.data.messageError);
        setOpenError(true);
      }
      else {
        setErrorMessage('');
        setSuccessMessage('');
        setOpenSuccess(false);
        setOpenError(false);
      }
    })
  }

  const updatePre = () => {
    axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/updateP`, {
      showP: showPre
    }, {
      headers: { 'Authorization': userToken }
    }).then(res => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (res.data.messageSuccess) {
        setSuccessMessage(res.data.messageSuccess);
        setOpenSuccess(true);
        setShowPre(!showPre)
      }
      else if (res.data.messageError) {
        setErrorMessage(res.data.messageError);
        setOpenError(true);
      }
      else {
        setErrorMessage('');
        setSuccessMessage('');
        setOpenSuccess(false);
        setOpenError(false);
      }
    })
  }
  const updateFacil = () => {
    axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/updateF`, {
      showF: showFacil
    }, {
      headers: { 'Authorization': userToken }
    }).then(res => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (res.data.messageSuccess) {
        setSuccessMessage(res.data.messageSuccess);
        setOpenSuccess(true);
        setShowFacil(!showFacil)
      }
      else if (res.data.messageError) {
        setErrorMessage(res.data.messageError);
        setOpenError(true);
      }
      else {
        setErrorMessage('');
        setSuccessMessage('');
        setOpenSuccess(false);
        setOpenError(false);
      }
    })
  }
  const updateMedio = () => {
    axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/updateM`, {
      showM: showMedia
    }, {
      headers: { 'Authorization': userToken }
    }).then(res => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (res.data.messageSuccess) {
        setSuccessMessage(res.data.messageSuccess);
        setOpenSuccess(true);
        setShowMedia(!showMedia)
      }
      else if (res.data.messageError) {
        setErrorMessage(res.data.messageError);
        setOpenError(true);
      }
      else {
        setErrorMessage('');
        setSuccessMessage('');
        setOpenSuccess(false);
        setOpenError(false);
      }
    })
  }
  const updateDificil = () => {
    axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/updateD`, {
      showD: showDificil
    }, {
      headers: { 'Authorization': userToken }
    }).then(res => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (res.data.messageSuccess) {
        setSuccessMessage(res.data.messageSuccess);
        setOpenSuccess(true);
        setShowDificil(!showDificil)
      }
      else if (res.data.messageError) {
        setErrorMessage(res.data.messageError);
        setOpenError(true);
      }
      else {
        setErrorMessage('');
        setSuccessMessage('');
        setOpenSuccess(false);
        setOpenError(false);
      }
    })
  }
  const deleteQuizPre = () => {
    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/deleteQuizP`, {
      headers: { 'Authorization': userToken }
    }
    ).then((res) => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (res.data.noAdmin) {
        history.push('/user');
      }
      else if (res.data.messageSuccess) {
        setSuccessMessage(res.data.messageSuccess);
        setOpenSuccess(true);

      }
      else if (res.data.messageError) {
        setErrorMessage(res.data.messageError);
        setOpenError(true);
      }
      else {
        setErrorMessage('');
        setSuccessMessage('');
        setOpenSuccess(false);
        setOpenError(false);
      }

    })
  }
  const deleteQuizFacil = () => {
    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/deleteQuizF`, {
      headers: { 'Authorization': userToken }
    }
    ).then((res) => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (res.data.noAdmin) {
        history.push('/user');
      }
      else if (res.data.messageSuccess) {
        setSuccessMessage(res.data.messageSuccess);
        setOpenSuccess(true);
      }
      else if (res.data.messageError) {
        setErrorMessage(res.data.messageError);
        setOpenError(true);
      }
      else {
        setErrorMessage('');
        setSuccessMessage('');
        setOpenSuccess(false);
        setOpenError(false);
      }

    })
  }
  const deleteQuizMedia = () => {
    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/deleteQuizM`, {
      headers: { 'Authorization': userToken }
    }
    ).then((res) => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (res.data.noAdmin) {
        history.push('/user');
      }
      else if (res.data.messageSuccess) {
        setSuccessMessage(res.data.messageSuccess);
        setOpenSuccess(true);
      }
      else if (res.data.messageError) {
        setErrorMessage(res.data.messageError);
        setOpenError(true);
      }
      else {
        setErrorMessage('');
        setSuccessMessage('');
        setOpenSuccess(false);
        setOpenError(false);
      }

    })
  }
  const deleteQuizDificil = () => {
    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/learningAdmin/deleteQuizD`, {
      headers: { 'Authorization': userToken }
    }
    ).then((res) => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (res.data.noAdmin) {
        history.push('/user');
      }
      else if (res.data.messageSuccess) {
        setSuccessMessage(res.data.messageSuccess);
        setOpenSuccess(true);
      }
      else if (res.data.messageError) {
        setErrorMessage(res.data.messageError);
        setOpenError(true);
      }
      else {
        setErrorMessage('');
        setSuccessMessage('');
        setOpenSuccess(false);
        setOpenError(false);
      }

    })
  }
  return (
    <div className="learn-admin">
      <div className="height11vh"></div>

      <Paper className="pageContentTeam">
        <div className="headTableAdmin">
          <h1>Listado de módulos de aprendizaje</h1>
          <Button variant="outlined" color="primary" onClick={() => {
            setTitle("");
            setContent("");
            setType("");
            openCloseModalContent();
          }}>Nuevo módulo</Button>
        </div>
        <TblContainer>
          <TblHead />
          <TableBody>
            {
              recordsAfterPagingAndSorting().map(item => (
                <TableRow key={item.learn_id} >
                  <TableCell>{item.title}</TableCell>
                  <TableCell>{item.category}</TableCell>
                  <TableCell>{item.level}</TableCell>
                  <TableCell>
                    <IconButton onClick={(e) => { modifyContent(item) }}>
                      <Edit fontSize="small" color="primary" />
                    </IconButton>
                    <IconButton color="secondary" onClick={() => { handleOpenRemoveDialog(item.learn_id) }}>
                      <Cancel fontSize="small" />
                    </IconButton>
                  </TableCell>

                </TableRow>
              ))
            }
          </TableBody>
        </TblContainer>
        <TblPagination />
      </Paper>
      <Modal open={modalCreateContent} onClose={openCloseModalContent} className="modalMarginBottom20">
        <Paper className="pageContentTeam2">
          <h1>Contenido de aprendizaje</h1>
          <br />
          <div className="headContent">
            <Grid
              item
              md={12}
              xs={12}
            >
              <TextField
                fullWidth
                value={title}
                label="Tema"
                name="title"
                required
                variant="outlined"
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
              />
            </Grid>

          </div>
          <br />
          <div className="headContent">
            <Grid item
              md={6}
              xs={12}>
              <label id="userType">Categoría</label>
              <Select labelId="userType" name="Tipo" className="selectCa" value={type} onChange={(e) => { setType(e.target.value) }} >
                <MenuItem value="">
                  <em>Ninguno</em>
                </MenuItem>
                <MenuItem value={1}>Esteganografía</MenuItem>
                <MenuItem value={2}>Criptografía</MenuItem>
                <MenuItem value={3}>OSINT</MenuItem>
                <MenuItem value={4}>Pwn</MenuItem>
                <MenuItem value={5}>Explotación Web</MenuItem>
                <MenuItem value={6}>Fundamentos</MenuItem>
                <MenuItem value={7}>Ingeniería Inversa</MenuItem>
                <MenuItem value={8}>Programación</MenuItem>
                <MenuItem value={9}>Seguridad Móvil</MenuItem>
                <MenuItem value={10}>Explotación</MenuItem>
                <MenuItem value={11}>Misceláneo</MenuItem>
                <MenuItem value={12}>Análisis Forense</MenuItem>
              </Select>
            </Grid>
            <Grid item
              md={6}
              xs={12}>
              <label id="userLevel">Nivel</label>
              <Select labelId="userLevel" name="Nivel" className="selectCa" value={level} onChange={(e) => { setLevel(e.target.value) }} >
                <MenuItem value="">
                  <em>Ninguno</em>
                </MenuItem>
                <MenuItem value="Fácil">Fácil</MenuItem>
                <MenuItem value="Intermedio">Intermedio</MenuItem>
                <MenuItem value="Difícil">Difícil</MenuItem>
              </Select>
            </Grid>
          </div>
          <br />
          <Grid item
            md={12}
            xs={12}>
            <SunEditor  lang="es" onChange={handleSetContext} setOptions={{
              height: 200,
              language:'es',
              buttonList: [['font','fontSize','bold','underline','fontColor'],
              ['align'],['list'],['table'], ['image'],['video'],['link'],['preview'],['codeView'],['print']] // Or Array of button list, eg. [['font', 'align'], ['image']]

            }} /></Grid>
          <br />

          <Grid item
          >
            <Button color="primary" variant="contained" onClick={(e) => { submitContent() }}>Enviar</Button>
          </Grid>
        </Paper>
      </Modal>
      <Modal open={modalEditContent} onClose={openCloseModalContentEdit} className="modalMarginBottom20">
        <Paper className="pageContentTeam2">
          <h1>Editar contenido de aprendizaje</h1>
          <br />
          <div className="headContent">
            <Grid
              item
              md={12}
              xs={12}
            >
              <TextField
                fullWidth
                value={titleEdit}
                label="Tema"
                name="title"
                required
                variant="outlined"
                onChange={(e) => {
                  setTitleEdit(e.target.value);
                }}
              />
            </Grid>

          </div>
          <br />
          <div className="headContent">
            <Grid item
              md={6}
              xs={12}>
              <label id="userType">Categoría</label>
              <Select labelId="userType" name="Tipo" className="selectCa" value={typeEdit} onChange={(e) => { setTypeEdit(e.target.value) }} >
                <MenuItem value="">
                  <em>Ninguno</em>
                </MenuItem>
                <MenuItem value={1}>Esteganografía</MenuItem>
                <MenuItem value={2}>Criptografía</MenuItem>
                <MenuItem value={3}>OSINT</MenuItem>
                <MenuItem value={4}>Pwn</MenuItem>
                <MenuItem value={5}>Explotación Web</MenuItem>
                <MenuItem value={6}>Fundamentos</MenuItem>
                <MenuItem value={7}>Ingeniería Inversa</MenuItem>
                <MenuItem value={8}>Programación</MenuItem>
                <MenuItem value={9}>Seguridad Móvil</MenuItem>
                <MenuItem value={10}>Explotación</MenuItem>
                <MenuItem value={11}>Misceláneo</MenuItem>
                <MenuItem value={12}>Análisis Forense</MenuItem>
              </Select>
            </Grid>
            <Grid item
              md={6}
              xs={12}>
              <label id="userLevel">Nivel</label>
              <Select labelId="userLevel" name="Nivel" className="selectCa" value={levelEdit} onChange={(e) => { setLevelEdit(e.target.value) }} >
                <MenuItem value="">
                  <em>Ninguno</em>
                </MenuItem>
                <MenuItem value="Fácil">Fácil</MenuItem>
                <MenuItem value="Intermedio">Intermedio</MenuItem>
                <MenuItem value="Difícil">Difícil</MenuItem>
              </Select>
            </Grid>
          </div>
          <br />
          <Grid item
            md={12}
            xs={12}>
            <SunEditor  lang="es" defaultValue={contentEdit} onChange={handleSetContextEdit} setOptions={{
              height: 200,
              language:'es',
              buttonList: [['font','fontSize','bold','underline','fontColor'],
              ['align'],['list'],['table'], ['image'],['video'],['link'],['preview'],['codeView'],['print']] // Or Array of button list, eg. [['font', 'align'], ['image']]

            }} /></Grid>
          <br />

          <Grid item
          >
            <Button color="primary" variant="contained" onClick={(e) => { updateContent() }}>Enviar</Button>
          </Grid>
        </Paper>
      </Modal>
      <Paper className="pageContentTeam2">
        <div className="headTableAdmin">
          <h1>Retos para los módulos de aprendizaje</h1>
          <Button variant="outlined" color="primary" onClick={() => {
            openCloseModal();
          }}>Nuevo Reto</Button>
        </div>
        <TblContainerFlag>
          <TblHeadFlag />
          <TableBody>
            {
              recordsAfterPagingAndSortingFlag().map(item => (
                <TableRow key={item.flag_id} >
                  <TableCell>{item.title}</TableCell>
                  <TableCell>{item.question}</TableCell>
                  <TableCell>{item.score}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => { openModalEdit(item.flag_id) }}>
                      <Edit fontSize="small" color="primary" />
                    </IconButton>
                    <IconButton color="secondary" onClick={() => { handleOpenRemoveDialogFlag(item.flag_id) }}>
                      <Cancel fontSize="small" />
                    </IconButton>
                  </TableCell>

                </TableRow>
              ))
            }
          </TableBody>
        </TblContainerFlag>
        <TblPaginationFlag />


      </Paper>
      <Paper className="pageContentTeam2">
        <div className="headTableAdmin">
          <h1>Configuración de encuestas</h1>

        </div>
        <div className="quiz">
          <div className="buttonsQuizMarginLeft">
            <Button variant="outlined" onClick={deleteQuizPre} color='primary' >Reiniciar Inicial</Button>
            <FormControlLabel control={<Checkbox checked={showPre} value={showPre} className="formColor" color="primary" onChange={updatePre} />} label="Mostrar Inicial" />
          </div>
          <div className="buttonsQuiz">
            <Button className="buttonGreenAdmin" variant="outlined" onClick={deleteQuizFacil}>Reiniciar Fácil</Button>
            <FormControlLabel control={<Checkbox checked={showFacil} className="formGreenAdmin" value={showFacil} onChange={updateFacil} />} label="Mostrar Fácil" />
          </div>
          <div className="buttonsQuiz">
            <Button className="buttonColorAdmin" variant="outlined" onClick={deleteQuizMedia}>Reiniciar Intermedio</Button>
            <FormControlLabel control={<Checkbox checked={showMedia} className="formColor2Admin" value={showMedia} onChange={updateMedio} />} label="Mostrar Intermedio" />

          </div>
          <div className="buttonsQuiz">
            <Button color="secondary" variant="outlined" onClick={deleteQuizDificil}>Reiniciar Difícil</Button>
            <FormControlLabel control={<Checkbox checked={showDificil} color="secondary" className="formColor3Admin" value={showDificil} onChange={updateDificil} />} label="Mostrar Difícil" />

          </div>
        </div>

      </Paper>
      <Paper className="pageContentTeam2">
        <div className="headTableAdmin">
          <h1>Encuesta de aprendizaje</h1>
          <Button variant="outlined" color="primary" onClick={() => {
            openCloseModalQuiz();
          }}>Nueva Pregunta</Button>
        </div>
        <TblContainerQuiz>
          <TblHeadQuiz />
          <TableBody>
            {
              recordsAfterPagingAndSortingQuiz().map(item => (
                <TableRow key={item.question_id} >
                  <TableCell>{item.question}</TableCell>
                  <TableCell>{item.level}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => { openModalQuizEdit(item.question_id) }}>
                      <Edit fontSize="small" color="primary" />
                    </IconButton>
                    <IconButton color="secondary" onClick={() => { handleOpenRemoveDialogQuiz(item.question_id) }}>
                      <Cancel fontSize="small" />
                    </IconButton>
                  </TableCell>

                </TableRow>
              ))
            }
          </TableBody>
        </TblContainerQuiz>
        <TblPaginationQuiz />
      </Paper>

      <Modal open={modalCreate} onClose={openCloseModal}>
        <div className="modalCreate">
          <Card >
            <CardHeader
              title="Crear nuevo reto"
            />
            <Divider />
            <CardContent>
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Pregunta"
                    name="question"
                    required
                    variant="outlined"
                    onChange={(e) => {
                      setQuestion(e.target.value)
                    }}
                  />

                </Grid>

                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <div className="divFlexCenter">
                    <TextField
                      fullWidth
                      label="Flag"
                      name="flag"
                      type={passwordShown ? "text" : "password"}
                      variant="outlined"
                      onChange={(e) => {
                        setFlag(e.target.value)
                      }}
                    />
                    <VisibilityIcon onClick={togglePassword} className="iconMarginCursor" />
                  </div>
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Valor"
                    name="value"
                    variant="outlined"
                    required
                    select
                    SelectProps={{ native: true }}
                    onChange={(e) => {
                      setScore(e.target.value)
                    }}
                  >
                    {points.map((option, index) => (
                      <option
                        key={index}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Modulo"
                    name="module"
                    variant="outlined"
                    required
                    select
                    SelectProps={{ native: true }}
                    onChange={(e) => {
                      setLearn_id(e.target.value)
                    }}
                  >
                    {recordsTitles.map((option, index) => (
                      <option
                        key={index}
                        value={option.learn_id}
                      >
                        {option.title}
                      </option>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <Box
            className="boxFlexJustifyContent"
            >
              <Button type='submit' variant="outlined" color="primary" className="buttonModified"
                onClick={onSubmitFlag}>
                Crear
              </Button>
              <Button type='submit' variant="outlined" color="secondary" className="buttonModified"
                onClick={openCloseModal}>
                Cancelar
              </Button>
            </Box>
          </Card>

        </div>
      </Modal>
      <Modal open={modalEdit} onClose={closeModalEdit}>
        <div className="modalEdit">
          <Card >
            <CardHeader
              title="Modificar el reto"
            />
            <Divider />
            <CardContent>
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Pregunta"
                    name="question"
                    value={questionEdit}
                    required
                    variant="outlined"
                    onChange={(e) => {
                      setQuestionEdit(e.target.value)
                    }}
                  />

                </Grid>

                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <div className="divFlexCenter">
                    <TextField
                      fullWidth
                      label="Flag"
                      name="flag"
                      value={flagEdit}
                      type={passwordShownEdit ? "text" : "password"}
                      variant="outlined"
                      onChange={(e) => {
                        setFlagEdit(e.target.value)
                      }}
                    />
                    <VisibilityIcon onClick={togglePasswordEdit} className="iconMarginCursor" />

                  </div>
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Valor"
                    name="value"
                    value={scoreEdit}
                    variant="outlined"
                    required
                    select
                    SelectProps={{ native: true }}
                    onChange={(e) => {
                      setScoreEdit(e.target.value)
                    }}
                  >
                    {points.map((option, index) => (
                      <option
                        key={index}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                </Grid>

              </Grid>
            </CardContent>
            <Divider />
            <Box
              className="boxFlexJustifyContent"
            >
              <Button type='submit' variant="outlined" color="primary" className="buttonModified"
                onClick={onUpdateFlag}>
                Actualizar
              </Button>
              <Button type='submit' variant="outlined" color="secondary" className="buttonModified"
                onClick={closeModalEdit}>
                Cancelar
              </Button>
            </Box>
          </Card>

        </div>
      </Modal>
      <Modal open={modalQuiz} onClose={openCloseModalQuiz}>
        <div className="modalCreate">
          <Card >
            <CardHeader
              title="Crear nueva pregunta"
            />
            <Divider />
            <CardContent>
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Pregunta"
                    name="question"
                    required
                    variant="outlined"
                    onChange={(e) => {
                      setQuestionQuiz(e.target.value)
                    }}
                  />

                </Grid>

                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <div className="divFlexCenter">
                    <TextField
                      fullWidth
                      label="Respuesta correcta"
                      name="answer"
                      type={passwordShownQuiz ? "text" : "password"}
                      variant="outlined"
                      onChange={(e) => {
                        setAnswerQuiz(e.target.value)
                      }}
                    />
                    <VisibilityIcon onClick={togglePasswordQuiz} className="iconMarginCursor" />
                  </div>
                </Grid>
                <Grid item
                  md={6}
                  xs={12}>
                  <label id="userLevel">Nivel</label>
                  <Select labelId="userLevel" name="Nivel" className="selectCa" value={levelQuiz} onChange={(e) => { setLevelQuiz(e.target.value) }} >
                    <MenuItem value="">
                      <em>Ninguno</em>
                    </MenuItem>
                    <MenuItem value="Inicial">Inicial</MenuItem>
                    <MenuItem value="Fácil">Fácil</MenuItem>
                    <MenuItem value="Intermedio">Intermedio</MenuItem>
                    <MenuItem value="Difícil">Difícil</MenuItem>
                  </Select>
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                ></Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Respuesta 1"
                    name="answer1"
                    required
                    variant="outlined"
                    onChange={(e) => {
                      setAnswerOne(e.target.value)
                    }}
                  />

                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Respuesta 2"
                    name="answer2"
                    required
                    variant="outlined"
                    onChange={(e) => {
                      setAnswerTwo(e.target.value)
                    }}
                  />

                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Respuesta 3"
                    name="answer3"
                    required
                    variant="outlined"
                    onChange={(e) => {
                      setAnswerThree(e.target.value)
                    }}
                  />

                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Respuesta 4"
                    name="answer4"
                    required
                    variant="outlined"
                    onChange={(e) => {
                      setAnswerFour(e.target.value)
                    }}
                  />

                </Grid>

              </Grid>
            </CardContent>
            <Divider />
            <Box
              className="boxFlexJustifyContent"
            >
              <Button type='submit' variant="outlined" color="primary" className="buttonModified"
                onClick={onSubmitQuiz}>
                Crear
              </Button>
              <Button type='submit' variant="outlined" color="secondary" className="buttonModified"
                onClick={openCloseModalQuiz}>
                Cancelar
              </Button>
            </Box>
          </Card>

        </div>
      </Modal>
      <Modal open={modalQuizEdit} onClose={openCloseModalQuizEdit}>
        <div className="modalCreate">
          <Card >
            <CardHeader
              title="Editar pregunta"
            />
            <Divider />
            <CardContent>
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Pregunta"
                    name="question"
                    required
                    value={questionQuizEdit}
                    variant="outlined"
                    onChange={(e) => {
                      setQuestionQuizEdit(e.target.value)
                    }}
                  />

                </Grid>

                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <div className="divFlexCenter">
                    <TextField
                      fullWidth
                      label="Respuesta correcta"
                      name="answer"
                      value={answerQuizEdit}
                      type={passwordShownQuizEdit ? "text" : "password"}
                      variant="outlined"
                      onChange={(e) => {
                        setAnswerQuizEdit(e.target.value)
                      }}
                    />
                    <VisibilityIcon onClick={togglePasswordQuizEdit} className="iconMarginCursor" />
                  </div>
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Respuesta 1"
                    name="answer1"
                    value={answerOneEdit}
                    required
                    variant="outlined"
                    onChange={(e) => {
                      setAnswerOneEdit(e.target.value)
                    }}
                  />

                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Respuesta 2"
                    name="answer2"
                    required
                    value={answerTwoEdit}
                    variant="outlined"
                    onChange={(e) => {
                      setAnswerTwoEdit(e.target.value)
                    }}
                  />

                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Respuesta 3"
                    name="answer3"
                    value={answerThreeEdit}
                    required
                    variant="outlined"
                    onChange={(e) => {
                      setAnswerThreeEdit(e.target.value)
                    }}
                  />

                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Respuesta 4"
                    name="answer4"
                    value={answerFourEdit}
                    required
                    variant="outlined"
                    onChange={(e) => {
                      setAnswerFourEdit(e.target.value)
                    }}
                  />

                </Grid>

              </Grid>
            </CardContent>
            <Divider />
            <Box
              className="boxFlexJustifyContent"
            >
              <Button type='submit' variant="outlined" color="primary" className="buttonModified"
                onClick={onUpdateQuiz}>
                Actualizar
              </Button>
              <Button type='submit' variant="outlined" color="secondary" className="buttonModified"
                onClick={openCloseModalQuizEdit}>
                Cancelar
              </Button>
            </Box>
          </Card>

        </div>
      </Modal>
      <div className="divMarginHeigth"></div>
      <Snackbar open={openError} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error" className="alertWidthTop">
          {error}
        </Alert>
      </Snackbar>
      <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" className="alertWidthTop">
          {success}
        </Alert>
      </Snackbar>
      <Dialog
        open={openRemoveDialog}
        onClose={handleCloseRemoveDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Eliminar Módulo"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Está seguro que desea eliminar el módulo?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => { deleteContent(removeModuleID) }}>Sí</Button>
          <Button onClick={handleCloseRemoveDialog} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openRemoveDialogFlag}
        onClose={handleCloseRemoveDialogFlag}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Eliminar Reto"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Está seguro que desea eliminar el reto?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => { deleteFlag(removeFlagID) }}>Sí</Button>
          <Button onClick={handleCloseRemoveDialogFlag} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openRemoveDialogQuiz}
        onClose={handleCloseRemoveDialogQuiz}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Eliminar Pregunta"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Está seguro que desea eliminar la pregunta?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => { deleteQuiz(removeQuizID) }}>Sí</Button>
          <Button onClick={handleCloseRemoveDialogQuiz} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

